import ExempleFeatureReducer from '../../features/exemple/redux';

const ReducerRoot = {
    ...ExempleFeatureReducer,
};

export default ReducerRoot;
